import { createSelector } from "reselect";
import { isDefined, uniqueByKey, memoize } from "@ls/js-utils";
import SelectionState from "state/selections/SelectionState";
import scope from "./scope";
import SummaryType from "state/selections/Constants/SummaryType";

export const selectScan2CalcTypeOptions = (state) => state[scope].options;
export const selectData = (summaryType) => (state) =>
  state[scope]["data"][summaryType];
export const selectFetchingData = (summaryType) => (state) =>
  state[scope]["fetchingData"][summaryType];

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectRowsMap = createSelector(
  selectDefinitions(SelectionState.COMMITTED),
  selectData(SummaryType.ABSOLUTE),
  selectData(SummaryType.RELATIVE),
  (scan2Definitions, absData, relData) => {
    const toRowsMap = (groupingData, scan2Definitions) => {
      const entityRowsMap = {};
      if (groupingData?.var?.length) {
        groupingData.var.forEach((varSummary) => {
          const { primaryKey = {}, values = {} } = varSummary;
          const { entityId } = primaryKey;


          if (!isDefined(entityRowsMap[entityId])) {
            entityRowsMap[entityId] = {};
          }

          scan2Definitions
            //.filter(({ scan2CalcType }) => scan2CalcType === values[0]["primaryKey"]["calcType"])
            .forEach((scan2Definition) => {
              const { percentiles, summary } = scan2Definition;
              const scan2Var = values?.find(({ primaryKey }) => primaryKey.calcType === scan2Definition.scan2CalcType && primaryKey.percentile === scan2Definition.percentiles);
              //const value = scan2Var?.value?.find(i => i.percentile === percentiles)?.value;
              //const value = values[factor.toLowerCase()]; //factors are keyed by lower case values for some reason
              if (isDefined(scan2Var?.value)) {
                //scan2 - PARAM, 97.5, ABSOLUTE
                entityRowsMap[entityId][
                  `scan2 - ${scan2Definition.scan2CalcType}, ${percentiles.toFixed()}, ${summary}`
                ] = scan2Var.value;
              }
            });
        });
      }
      return entityRowsMap;
    };

    const absRowsMap = toRowsMap(
      absData,
      scan2Definitions.filter(({ summary }) => summary === SummaryType.ABSOLUTE)
    );
    const relRowsMap = toRowsMap(
      relData,
      scan2Definitions.filter(({ summary }) => summary === SummaryType.RELATIVE)
    );

    const result = { ...absRowsMap };
    Object.entries(relRowsMap).forEach(([entityId, relFields]) => {
      if (!result[entityId]) {
        result[entityId] = {};
      }
      result[entityId] = {
        ...result[entityId],
        ...relFields,
      };
    });
    return result;
  }
);
